import * as React from 'react'

const SvgInformationCircleOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 25"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M4.219 12.76a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0m8.25-9.75c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.366 9.75-9.75-4.366-9.75-9.75-9.75m0 5a1 1 0 0 0-1 1v.007a1 1 0 0 0 1 1h.007a1 1 0 0 0 1-1v-.008a1 1 0 0 0-1-1zm-1.645 4.447a1 1 0 0 0 .794.547c.066.007.117.069.1.133l-.574 2.298c-.363 1.45 1.143 2.658 2.48 1.99l.042-.021a1 1 0 0 0-.347-1.89c-.066-.006-.116-.068-.1-.133l.574-2.297c.363-1.45-1.143-2.658-2.48-1.99l-.042.02a1 1 0 0 0-.447 1.342"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgInformationCircleOutlined
